import Index from './index.vue'

const router = [
    {
        path: '',
        component: Index,
        name: 'customer_partitions',
    },
]

export default router;
